import { Component, input, output } from '@angular/core';
import { LowerCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ProfileCompletionItemLibComponent } from '@components/atoms';
import { IProfileCompletionLevel } from '@core/interface';
import { ProfileCompletionItem } from '@core/enums';
import { ProfileModalConfigService } from '@core/services';

@Component({
  standalone: true,
  selector: 'lib-profile-level-section',
  templateUrl: './profile-level-section.component.html',
  styleUrls: ['./profile-level-section.component.scss'],
  imports: [
    TranslateModule,
    LowerCasePipe,
    ProfileCompletionItemLibComponent,
  ],
})
export class ProfileLevelSectionComponent {
  title = input.required<string>();
  levelItems = input.required<ProfileCompletionItem[]>();
  levelData = input.required<IProfileCompletionLevel>();
  modalConfigService = input.required<ProfileModalConfigService>();

  linkClicked = output<ProfileCompletionItem>();

  isItemCompleted(item: ProfileCompletionItem, completedItems: ProfileCompletionItem[]): boolean {
    return completedItems.includes(item);
  }
}
